import IMask from 'imask';
import { mount } from '../dom-lifecycle';

mount('[data-mask]', function () {
	let imask = this._imask = new IMask(this, {
		mask: this.dataset.mask.startsWith('/') && this.dataset.mask.endsWith('/') ?
			new RegExp(this.dataset.mask.slice(1, -1)) :
			this.dataset.mask,
	});
	$(this).on('input', () => imask.value = this.value);
	$(this.form).on('reset', () => imask.masked.reset());
	let update = () => $(this).toggleRuleValid('mask', imask.masked.isComplete);
	imask.on('accept', update);
	update();
});

mount('[data-repeat]', function () {
	let repeatedInput = this.form.elements[this.dataset.repeat];
	let update = () => $(this).toggleRuleValid('repeat', this.value == repeatedInput.value);
	$([this, repeatedInput]).on('input change', update);
	update();
});

mount('[data-no-paste]', function () {
	this.addEventListener('paste', e => e.preventDefault());
	this.addEventListener('drop', e => e.preventDefault());
});